import _ from 'lodash';
import BaseCtrl from 'edge/platform/base/BaseCtrl';
import MockUpUtil from 'edge/api/gw-portals-util-js/MockUpUtil';
import MetadataDrivenUtil from 'edge/api/gw-portals-driven-ui-js/MetadataDrivenUtil';

/**
 * This function prepares some common actions to be used in flow configuration
 *
 * @param {Object} dependencies
 * @param {Object} dependencies.$q a Promise implementation
 * @param {Object} dependencies.LoadSaveService
 * @param {Object} dependencies.ViewModelService
 * @param {Object} dependencies.ViewModelContext
 *
 * @returns {Object} a set of common Flow actions 'ret.ACTIONS' an their respective message 'ret.ACTIONS_MSG' to be used across all the custom flows
 */

const mockUpUtil = new MockUpUtil();

const fn = ($filter, $scope, $state, $stateParams, PolicyService, $translate,
    ViewModelService, InsuranceSuiteMetadata, UserInfoService, ModalService) => {
    const ctrl = Object.create(BaseCtrl);

//     "PSA.Web.PSAReport.Producer-Code": "Producer Code",
//   "PSA.Web.PSAReport.Producer-Name": "Producer Name",
//   "PSA.Web.PSAReport.Organization-Name": "Organization Name",
//   "PSA.Web.PSAReport.IsActiveOrCancel": "Active/Cancel",
//   "PSA.Web.PSAReport.YearOfSubscription": "Year Of Subscription",
//   "PSA.Web.PSAReport.SellerCode": "Seller Code"
        $scope.data = [];
        var viewModel = {};
       
       const today = new Date();
       
       $scope.today = {
           year: today.getFullYear(),
           month: today.getMonth(),
           day: today.getDate()
       };
    ctrl.init = () => {
        //Check if we have admin access or redirect to home page
        
        // $scope.submissionView = ViewModelService.create(viewModel, 'pc', 'edge.capabilities.quote.submission.dto.ReportDTO');
        // //$scope.submissionView.yearOfSubscription.value = $scope.today;
        // const operation = PolicyService.getPoliciess();
        // operation.then((result) => {
        //     console.log(result);
        //     $scope.data  = result;
        //    // ModalService.showInfo('gateway.views.account-detail.Saved Title', 'gateway.views.account-detail.Saved Message');
        // }).catch((error) => {
        //     ModalService.showError('gateway.views.modal.Error', 'quoteandbind.views.contact-us.Please contact us with the reference number below and we would be pleased to assist you.');
        // });
    };

    ctrl.save = function (form) {
        //var tsv = $scope.data.map(function(row) { return row.join('\t'); }).join('\n');
        //var blob = new Blob([tsv], {type:'application/vnd.ms-excel'});
        //return URL.createObjectURL(blob);  
        JSONToCSVConvertor($scope.data, "Policy Report", true);
    };
    function JSONToCSVConvertor(JSONData, ReportTitle, ShowLabel) {
        //If JSONData is not an object then JSON.parse will parse the JSON string in an Object
        var arrData = typeof JSONData != 'object' ? JSON.parse(JSONData) : JSONData;
        
        var CSV = 'sep=,' + '\r\n\n';
    
        //This condition will generate the Label/Header
        if (ShowLabel) {
            var row = "";
            
            //This loop will extract the label from 1st index of on array
            for (var index in arrData[0]) {
                
                //Now convert each value to string and comma-seprated
                row += index.toUpperCase() + ',';
            }
    
            row = row.slice(0, -1);
            
            //append Label row with line break
            CSV += row + '\r\n';
        }
        
        //1st loop is to extract each row
        for (var i = 0; i < arrData.length; i++) {
            var row = "";
            
            //2nd loop will extract each column and convert it in string comma-seprated
            for (var index in arrData[i]) {
                row += '"' + arrData[i][index] + '",';
            }
    
            row.slice(0, row.length - 1);
            
            //add a line break after each row
            CSV += row + '\r\n';
        }
    
        if (CSV == '') {        
            //alert("Invalid data");
            return;
        }   
        
        //Generate a file name
        var fileName = "MyReport_";
        //this will remove the blank-spaces from the title and replace it with an underscore
        fileName += ReportTitle.replace(/ /g,"_");   
        
        //Initialize file format you want csv or xls
        var uri = 'data:text/csv;charset=utf-8,' + escape(CSV);
        
        // Now the little tricky part.
        // you can use either>> window.open(uri);
        // but this will not work in some browsers
        // or you will not get the correct file extension    
        
        //this trick will generate a temp <a /> tag
        var link = document.createElement("a");    
        link.href = uri;
        
        //set the visibility hidden so it will not effect on your web-layout
        link.style = "visibility:hidden";
        link.download = fileName + ".csv";
        
        //this part will append the anchor tag and remove it after automatic click
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    
   
    return ctrl.create($scope);
};

fn.$inject = ['$filter', '$scope', '$state', '$stateParams', 'PolicyService', '$translate', 'ViewModelService', 'InsuranceSuiteMetadata', 'UserInfoService', 'ModalService'];
export default fn;